import React from 'react';
import Icon from './Icon';

const LayersIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 2L2 7.25l10 5.25 10-5.25L12 2zM2 12.25l10 5.25 10-5.25M2 17.25l10 5.25 10-5.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default LayersIcon;
